export const defaultPadSettings = [
  { id: '0', color: 'yellow', sample: './audio/Samples/Scratch1.wav' },
  { id: '1', color: 'red', sample: './audio/Samples/Horn1.mp3' },
  { id: '2', color: 'purple', sample: './audio/Samples/SynthShot-1.wav' },
  { id: '3', color: 'yellow', sample: './audio/Samples/CongaFinger.wav' },
  { id: '4', color: 'purple', sample: './audio/Samples/BassShot3.wav' },
  { id: '5', color: 'purple', sample: './audio/Samples/BassShot2.wav' },
  { id: '6', color: 'green', sample: './audio/Samples/Clap1.wav' },
  { id: '7', color: 'blue', sample: './audio/Samples/Brass1.wav' },
  { id: '8', color: 'blue', sample: './audio/Samples/Brass2.wav' },
  { id: '9', color: 'green', sample: './audio/Samples/Kick1.wav' },
  { id: '10', color: 'green', sample: './audio/Samples/Snare1.wav' },
  { id: '11', color: 'orange', sample: './audio/Samples/Vocal1.wav' },
];

export const allSamples = [
  { id: '1', name: 'BackSpin 1', path: './audio/Samples/Backspin1.wav' },
  { id: '2', name: 'BassLoop 1', path: './audio/Samples/BassLoop1.wav' },
  { id: '3', name: 'BassLoop 2', path: './audio/Samples/BassLoop2.wav' },
  { id: '4', name: 'BassShot 1', path: './audio/Samples/BassShot1.wav' },
  { id: '5', name: 'BassShot 2', path: './audio/Samples/BassShot2.wav' },
  { id: '6', name: 'BassShot 3', path: './audio/Samples/BassShot3.wav' },
  { id: '7', name: 'Bell 1', path: './audio/Samples/Bell1.wav' },
  { id: '8', name: 'Bongo 1', path: './audio/Samples/Bongo1.wav' },
  { id: '9', name: 'Bongo 2', path: './audio/Samples/Bongo2.wav' },
  { id: '10', name: 'Brass 1', path: './audio/Samples/Brass1.wav' },
  { id: '11', name: 'Brass 2', path: './audio/Samples/Brass2.wav' },
  { id: '12', name: 'Clap 1', path: './audio/Samples/Clap1.wav' },
  { id: '13', name: 'Clap 2', path: './audio/Samples/Clap2.wav' },
  { id: '14', name: 'Clap 3', path: './audio/Samples/Clap3.wav' },
  { id: '15', name: 'Conga Finger', path: './audio/Samples/CongaFinger.wav' },
  { id: '16', name: 'Crash 1', path: './audio/Samples/Crash1.wav' },
  { id: '17', name: 'Glitch 1', path: './audio/Samples/Glitch1.wav' },
  { id: '18', name: 'Glitch 2', path: './audio/Samples/Glitch2.wav' },
  { id: '19', name: 'HiHat 1', path: './audio/Samples/Hihat1.wav' },
  { id: '20', name: 'HiHat 2', path: './audio/Samples/Hihat2.wav' },
  { id: '21', name: 'Horn 1', path: './audio/Samples/Horn1.mp3' },
  { id: '22', name: 'Kick 1', path: './audio/Samples/Kick1.wav' },
  { id: '23', name: 'Kick 2', path: './audio/Samples/Kick2.wav' },
  { id: '24', name: 'Kick 3', path: './audio/Samples/Kick3.wav' },
  { id: '25', name: 'Scratch 1', path: './audio/Samples/Scratch1.wav' },
  { id: '26', name: 'Snare 1', path: './audio/Samples/Snare1.wav' },
  { id: '27', name: 'Snare 2', path: './audio/Samples/Snare2.wav' },
  { id: '28', name: 'SynthShot 1', path: './audio/Samples/SynthShot-1.wav' },
  { id: '29', name: 'SynthShot 2', path: './audio/Samples/SynthShot-2.wav' },
  { id: '30', name: 'Vocal 1', path: './audio/Samples/Vocal1.wav' },
  { id: '31', name: 'Vocal 2', path: './audio/Samples/Vocal2.wav' },
  { id: '32', name: 'Wobble 1', path: './audio/Samples/Wobble1.wav' },
];

export const defaultSequencerSettings = [
  {
    id: '0',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '1',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '2',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '3',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '4',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '5',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '6',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '7',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '8',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '9',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '10',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
  {
    id: '11',
    settings: [
      { id: '0', name: 'sequence0', value: 0, isActive: false },
      { id: '1', name: 'sequence1', value: 1, isActive: false },
      { id: '2', name: 'sequence2', value: 2, isActive: false },
      { id: '3', name: 'sequence3', value: 3, isActive: false },
      { id: '4', name: 'sequence4', value: 4, isActive: false },
      { id: '5', name: 'sequence5', value: 5, isActive: false },
      { id: '6', name: 'sequence6', value: 6, isActive: false },
      { id: '7', name: 'sequence7', value: 7, isActive: false },
      { id: '8', name: 'sequence8', value: 8, isActive: false },
      { id: '9', name: 'sequence9', value: 9, isActive: false },
      { id: '10', name: 'sequence10', value: 10, isActive: false },
      { id: '11', name: 'sequence11', value: 11, isActive: false },
      { id: '12', name: 'sequence12', value: 12, isActive: false },
      { id: '13', name: 'sequence13', value: 13, isActive: false },
      { id: '14', name: 'sequence14', value: 14, isActive: false },
      { id: '15', name: 'sequence15', value: 15, isActive: false },
      { id: '16', name: 'sequence16', value: 16, isActive: false },
      { id: '17', name: 'sequence17', value: 17, isActive: false },
      { id: '18', name: 'sequence18', value: 18, isActive: false },
      { id: '19', name: 'sequence19', value: 19, isActive: false },
      { id: '20', name: 'sequence20', value: 20, isActive: false },
      { id: '21', name: 'sequence21', value: 21, isActive: false },
      { id: '22', name: 'sequence22', value: 22, isActive: false },
      { id: '23', name: 'sequence23', value: 23, isActive: false },
      { id: '24', name: 'sequence24', value: 24, isActive: false },
      { id: '25', name: 'sequence25', value: 25, isActive: false },
      { id: '26', name: 'sequence26', value: 26, isActive: false },
      { id: '27', name: 'sequence27', value: 27, isActive: false },
      { id: '28', name: 'sequence28', value: 28, isActive: false },
      { id: '29', name: 'sequence29', value: 29, isActive: false },
      { id: '30', name: 'sequence30', value: 30, isActive: false },
      { id: '31', name: 'sequence31', value: 31, isActive: false },
    ],
  },
];
